import React from 'react';
import logoIcon from './assets/icon.png';
import aboutBanner from './assets/about_banner_1.png';
import aboutBg from './assets/about_us_bg.png';

const About = () => {
  return (
    <section 
      id="about" 
      className="about"
      style={{
        backgroundImage: `url(${aboutBg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative'
      }}
    >
      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(255, 255, 255, 0.92) 0%, rgba(240, 249, 255, 0.92) 100%)' }}></div>
      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        <div className="section-header">
          <h2 className="section-title" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '0' }}>
            Ab
            <img src={logoIcon} alt="o" style={{ width: '2.8rem', height: '2.8rem', objectFit: 'contain', margin: '0 -0.1rem', border: '2px solid #B8860B', borderRadius: '50%', padding: '2px' }} />ut Our Studi
            <img src={logoIcon} alt="o" style={{ width: '2.8rem', height: '2.8rem', objectFit: 'contain', margin: '0 -0.1rem', border: '2px solid #B8860B', borderRadius: '50%', padding: '2px' }} />
          </h2>
          <p className="section-subtitle">Crafting dreams under the moonlight</p>
        </div>
        <div className="about-content">
          <div className="about-text">
            <h3 style={{ fontFamily: "'Dancing Script', cursive", fontWeight: 700 }}>Where Magic Meets Cinema</h3>
            <p>
              Magic Moon Studios is at the forefront of next-generation film production. 
              We combine decades of cinematic expertise with breakthrough AI technology to 
              create immersive experiences that push the boundaries of visual storytelling.
            </p>
            <p>
              Our state-of-the-art facilities house the most advanced motion capture systems, 
              AI-powered visual effects tools, and real-time rendering capabilities, enabling 
              us to bring the impossible to life on screen.
            </p>
            <div className="about-features">
              <div className="feature-item">
                <span className="feature-icon">⚡</span>
                <h4>Real-Time Production</h4>
                <p>Instant visual feedback with cutting-edge real-time engines</p>
              </div>
              <div className="feature-item">
                <span className="feature-icon">🧠</span>
                <h4>AI-Enhanced VFX</h4>
                <p>Machine learning algorithms for unprecedented visual quality</p>
              </div>
              <div className="feature-item">
                <span className="feature-icon">🌟</span>
                <h4>Creative Excellence</h4>
                <p>Award-winning team of artists and technologists</p>
              </div>
            </div>
          </div>
          <div className="about-image">
            <img src={aboutBanner} alt="Studio" style={{ filter: 'brightness(1.05) contrast(1.1) saturate(1.15)' }} />
            <div className="image-overlay">
              <div className="play-button" style={{ background: 'none', border: '3px solid #B8860B', padding: '15px' }}>
                <img src={logoIcon} alt="Play" style={{ width: '50px', height: '50px', objectFit: 'contain' }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
